import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import './ImageSlide.css'

class PhotographerSlide extends Slide {

    render() {
        
        return super.render(
            <div className='ImageSlide'>
                <span className='ImageSlide-Title'>{ this.props.title }</span>
                {this.props.subtitle && <span className='ImageSlide-Subtitle'>{ this.props.subtitle }</span>}
                <img style={{maxWidth: '20vw'}} className='ImageSlide-Img' src={this.props.img} />
                <p style={{maxWidth: '90vw', margin: 0}}>{this.props.text}</p>
                <a href={this.props.link.href}>{this.props.link.text}</a>
            </div>
        )
    }
}

PhotographerSlide.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    img: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    link: PropTypes.object.isRequired
}

export default PhotographerSlide;





// WEBPACK FOOTER //
// ./src/components/PhotographerSlide.js